import React, { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import RouteContants from "../../constants/routesContent.json";
export const EmailVerificationContext = createContext({});

export const EmailVerficationContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const resetPassword = () => {
    navigate(RouteContants.RESET_PASSWORD);
  };
  const [text, setText] = useState("iom");
  const providerValue = {
    text,
    setText,
    resetPassword
  };

  return (
    <EmailVerificationContext.Provider value={providerValue}>
      {children}
    </EmailVerificationContext.Provider>
  );
};
